import { TreeSelect } from 'antd'
import { t } from 'i18next'
import { memo } from 'react'
import { useFilepathTree, useWorkspaceFolders } from '../hooks'

interface SelectWorkspaceFileProps {
  workspaceId?: string
  value?: string
  onChange?: (value: string) => void
  preventFetch?: boolean
  disabledIds?: string[]
}

const SelectWorkspaceFile = ({
  workspaceId,
  value,
  onChange,
  preventFetch = false,
  disabledIds = [],
}: SelectWorkspaceFileProps) => {
  const { workspaceFiles, isWorkspaceFilesLoading } = useWorkspaceFolders({
    workspaceId,
    preventFetch,
  })

  const { treeData } = useFilepathTree({
    files: workspaceFiles || [],
    disabledIds,
  })

  return (
    <TreeSelect
      value={value}
      onChange={onChange}
      placeholder={t(
        'workspaceDetailsPage.workspaceDocumentsPanel.addDocumentModal.folderPlaceholder'
      )}
      treeData={treeData}
      loading={isWorkspaceFilesLoading}
      treeDefaultExpandAll
      showSearch
    />
  )
}

export default memo(SelectWorkspaceFile)
